import { Grid } from '../../../shared/grid';

export const HelpHeader = () =>{
  return(
    <Grid row gap="md" tabIndex={0}>
      <Grid
        desktop={{col:12}}
        className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 padding-top-3">
            <h1 className="font-sans-2xl text-bold">FEMS Help</h1>
        </Grid>
    </Grid>
  )
}